import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('PrincipalPlatform', PrincipalPlatform);

    /* @ngInject */
    function PrincipalPlatform() {
        PrincipalPlatform.prototype = {
            build: build,
            buildEmpty: buildEmpty,
        };

        function PrincipalPlatform(platform) {
            if (!platform) {
                this.buildEmpty();
            } else {
                this.build(platform);
            }
        }

        return PrincipalPlatform;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.family = null;
            this.pcpEidOnPlatform = null;
            this.invoiceEm = null;
            this.invoiceRe = null;
            this.orderRe = null;
            this.orderEm = null;
            this.platformEid = null;
        }

        function build(platform) {
            this.id = platform.id || null;
            this.family = platform.family || null;
            this.pcpEidOnPlatform = platform.pcpEidOnPlatform || null;
            this.invoiceEm = platform.invoiceEm || null;
            this.invoiceRe = platform.invoiceRe || null;
            this.orderRe = platform.orderRe || null;
            this.orderEm = platform.orderEm || null;
            this.platformEid = platform.platformEid || null;
        }
    }
})();
